import React from 'react';
import Link from 'gatsby-link';
import Template from '../../../../components/templates/LoreHookConnect';
import Markdown from '../../../../components/Markdown';

export default (props) => {
  return (
    <Template>
      <h1>
        first
      </h1>
      <p>
        The <code>first</code> blueprint...
      </p>
    </Template>
  )
};



// WEBPACK FOOTER //
// ./src/pages/hooks/lore-hook-connect/blueprints/first.js